import {AnalyticsFilterItem} from '../analytics.types';
import _reduce from 'lodash/reduce';

export default function getFiltersQuery(filters: AnalyticsFilterItem[]) {
  return _reduce(
    filters,
    (accumulator, filter) => {
      const {filterBy, allValues} = filter;

      return {...accumulator, ...(allValues.length && {[filterBy]: allValues})};
    },
    {},
  );
}
